module.exports = __webpack_public_path__ + "img/Kuwait Office4.42c6585.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/Kuwait/Kuwait Office4.jpeg
// module id = 1708
// module chunks = 1